import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { PRODUCT_DOMAIN } from "@/constants";
import {
  WithdrawalPolicyResponse,
  WithdrawalRequestPayload,
} from "@/types/withdrawal";
import { apiErrorMappings } from "@/utils/errors/api-error-map";
import { trimFormValue } from "@/utils/form-input.utils";
import { transformWithdrawalData } from "@/utils/withdrawal/withdrawal-formatter.utils";

import fetchWithdrawalPolicy from "./API/getWithdrawalPolicy";
import submitWithdrawalRequest from "./API/submitWithdrawalRequest";

export const getWithdrawalPolicy = createAsyncThunk(
  "withdrawal/getPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const response: WithdrawalPolicyResponse = await fetchWithdrawalPolicy();
      const transformedData = transformWithdrawalData(response);
      return transformedData;
    } catch (err: unknown) {
      const error = err as AxiosError;
      return rejectWithValue({
        message: error.message || "Failed to fetch withdrawal policy data",
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const submitWithdrawalRequestAction = createAsyncThunk(
  "withdrawal/submitRequest",
  async (
    {
      policyReference,
      withdrawalReason,
    }: { policyReference: string; withdrawalReason: string },
    { rejectWithValue }
  ) => {
    try {
      const payload: WithdrawalRequestPayload = {
        data: {
          type: "Policy",
          channel: "ONLINE",
          attributes: {
            domain: PRODUCT_DOMAIN,
            withdrawalRequest: {
              withdrawalReason: trimFormValue(withdrawalReason),
            },
          },
        },
      };

      const response: WithdrawalPolicyResponse = await submitWithdrawalRequest(
        policyReference,
        payload
      );
      const transformedData = transformWithdrawalData(response);

      return transformedData;
    } catch (err: unknown) {
      const error = err as AxiosError;
      const errorObj = await apiErrorMappings(error);
      return rejectWithValue(errorObj);
    }
  }
);
